import { defaultLanguage, normalizeLanguageCode, supportedLanguageCodes } from '../config/languages.js';

const reservedPrefixes = new Set([
  'api',
  'auth',
  'downloads',
  'shinyproxy',
  'shinyproxy-enter',
  'static',
  'assets',
  '_next'
]);

export const getLanguageFromPath = (pathname = '/') => {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return normalizeLanguageCode(firstSegment);
};

export const stripLanguageFromPath = (pathname = '/') => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const parts = normalizedPath.split('/').filter(Boolean);

  if (parts.length > 0 && supportedLanguageCodes.includes(parts[0])) {
    const stripped = `/${parts.slice(1).join('/')}`;
    return stripped === '/' || stripped === '' ? '/' : stripped;
  }

  return normalizedPath || '/';
};

export const isReservedPath = (pathname = '/') => {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return Boolean(firstSegment && reservedPrefixes.has(firstSegment));
};

export const localizePath = (pathname = '/', language = defaultLanguage) => {
  if (isReservedPath(pathname)) return pathname;

  const lang = normalizeLanguageCode(language) || defaultLanguage;
  const strippedPath = stripLanguageFromPath(pathname);
  return strippedPath === '/' ? `/${lang}` : `/${lang}${strippedPath}`;
};

export const isActiveLocalizedPath = (currentPath, targetPath) => {
  return stripLanguageFromPath(currentPath) === stripLanguageFromPath(targetPath);
};
